export enum answerActionTypes {
  CREATE_ANSWER_LOADING = 'CREATE_ANSWER_LOADING',
  CURRENT_ANSWER_LOADING = 'CURRENT_ANSWER_LOADING',
  SET_CURRENT_ANSWER = 'SET_CURRENT_ANSWER',
  SET_CURRENT_ANSWER_DATA = 'SET_CURRENT_ANSWER_DATA',
  CURRENT_ANSWER_FAILURE = 'CURRENT_ANSWER_FAILURE',
  SET_EDIT_MODE = 'SET_EDIT_MODE',
  ANSWERS_LOADING = 'ANSWERS_LOADING',
  SET_ANSWERS = 'SET_ANSWERS',
  SET_CHECKED_ANSWERS = 'SET_CHECKED_ANSWERS',
  ANSWERS_FAILURE = 'ANSWERS_FAILURE',
  SET_ANSWERS_TOTAL = 'SET_ANSWERS_TOTAL',
  //// POST/PUT/DELETE
  EDITING_ANSWER_LOADING = 'EDITING_ANSWER_LOADING',
  SET_EDITING_ANSWER = 'SET_EDITING_ANSWER',
  EDITING_ANSWER_FAILURE = 'EDITING_ANSWER_FAILURE',
  SET_IS_DATE_FROM_SAVED = 'SET_IS_DATE_FROM_SAVED',
  SET_IS_DATE_TO_SAVED = 'SET_IS_DATE_TO_SAVED',
  SET_DATE_FROM_OLD = 'SET_DATE_FROM_OLD ',
  SET_DATE_TO_OLD = 'SET_DATE_TO_OLD ',
  DELETING_ANSWERS_LOADING = 'DELETING_ANSWERS_LOADING',
  DELETING_ANSWERS_FAILURE = 'DELETING_ANSWERS_FAILURE',
  MARKING_AS_SENT_LOADING = 'MARKING_AS_SENT_LOADING',
  SET_NAVIGATE_TO_ID = 'SET_NAVIGATE_TO_ID',
}
